// extracted by mini-css-extract-plugin
module.exports = {"landingPagesContent":"landing-pages_landingPagesContent___1Oua"};